import Cesium from 'cesium';

import Logging from '~app/core/logging';

const log = Logging.getLogger('app.core.createBillboard');

export function createBillboard(location, image, {
  scale = 1.0,
  horizontalOrigin = "center",
  verticalOrigin = "center",
  ellipsoid = undefined,
} = {}) {
  return new Cesium.Entity({
    position: location.cartesian3(ellipsoid),
    billboard: {
      image,
      scale,
      horizontalOrigin: parseHorizontalOrigin(horizontalOrigin),
      verticalOrigin: parseVerticalOrigin(verticalOrigin),
    },
  });
}

function parseHorizontalOrigin(origin) {

  let cesiumOrigin = Cesium.HorizontalOrigin.CENTER;

  if (origin === "left") {
    cesiumOrigin = Cesium.HorizontalOrigin.LEFT;
  }
  else if (origin === "center") {
    cesiumOrigin = Cesium.HorizontalOrigin.CENTER;
  }
  else if (origin === "right") {
    cesiumOrigin = Cesium.HorizontalOrigin.RIGHT;
  }
  else {
    log.error(`Unsupported billboard horizontal origin: ${origin}`);
  }

  return cesiumOrigin;
}

function parseVerticalOrigin(origin) {

  let cesiumOrigin = Cesium.VerticalOrigin.CENTER;

  if (origin === "top") {
    cesiumOrigin = Cesium.VerticalOrigin.TOP;
  }
  else if (origin === "center") {
    cesiumOrigin = Cesium.VerticalOrigin.CENTER;
  }
  else if (origin === "bottom") {
    cesiumOrigin = Cesium.VerticalOrigin.BOTTOM;
  }
  else if (origin === "baseline") {
    cesiumOrigin = Cesium.VerticalOrigin.BASELINE;
  }
  else {
    log.error(`Unsupported billboard vertical origin: ${origin}`);
  }

  return cesiumOrigin;
}

export default createBillboard;



// WEBPACK FOOTER //
// ./src/core/createBillboard.js